/**
 * Typed tenant billing API facade over the generated contract client.
 */

import { z } from 'zod';
import { tenantBillingApi } from '../api/generated/tenantBilling.api.js';
import {
  BillingPortalSessionResponseSchema,
  type TenantBillingSummaryResponse,
} from '@cnapse/shared/schemas.js';

class TenantBillingService {
  async getTenantBillingSummary(): Promise<TenantBillingSummaryResponse> {
    return tenantBillingApi.getSummary() as Promise<TenantBillingSummaryResponse>;
  }

  async createPortalSession(
    returnUrl?: string,
  ): Promise<z.infer<typeof BillingPortalSessionResponseSchema>> {
    try {
      return (await tenantBillingApi.createPortalSession({
        returnUrl: returnUrl ?? `${window.location.origin}/billing`,
      })) as z.infer<typeof BillingPortalSessionResponseSchema>;
    } catch (error) {
      console.error('Failed to create portal session:', error);
      throw new Error(
        error instanceof Error ? error.message : 'Failed to open billing portal',
      );
    }
  }
}

export const tenantBillingService = new TenantBillingService();
